(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('observation-definitions', {
            parent: 'entity',
            url: '/observation-definitions',
            data: {
                authorities: ['ROLE_INSTRUMENT_COORDINATOR', 'ROLE_INSTRUMENT_TEAM_MEMBER', 'ROLE_USER', 'ROLE_POWER_USER', 'ROLE_PLAN_COORDINATOR', 'ROLE_ADMIN'],
                pageTitle: 'Observation Definitions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/observation-definitions/observation-definitions.html',
                    controller: 'ObservationDefinitionsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        }).state('observation-definitions-detail', {
            parent: 'entity',
            url: '/observation-definitions/{id}',
            data: {
                authorities: ['ROLE_INSTRUMENT_COORDINATOR', 'ROLE_INSTRUMENT_TEAM_MEMBER', 'ROLE_USER', 'ROLE_POWER_USER', 'ROLE_PLAN_COORDINATOR', 'ROLE_ADMIN'],
                pageTitle: 'Observation Definitions detail'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/observation-definitions/observation-definitions-detail.html',
                    controller: 'ObservationDefinitionsDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'observation-definitions',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        }).state('observation-definitions.nexus', {
            parent: 'observation-definitions',
            url: '/nexus',
            data: {
                authorities: ['ROLE_PLAN_COORDINATOR']
            },
            onEnter: ['$state', '$uibModal', function ($state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/observation-definitions/observation-definitions-nexus.html',
                    controller: 'ObservationDefinitionsNexusController',
                    controllerAs: 'vm',
                    size: 'lg',
                    backdrop: 'static'
                }).result.then(function () {
                    $state.go('observation-definitions', null, {reload: true});
                }, function () {
                    $state.go('observation-definitions', null, {reload: true});
                });
            }]
        });
    }
})();
